import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MySelect } from "..";
import { Link, useNavigate } from "react-router-dom";
import appConfig from "../../config";
import { BsTrash3Fill } from "react-icons/bs";
import axios from "axios";
import { toast } from "react-toastify"
import { set } from "local-storage";

// import { ShoppingCart } from "@material-ui/icons";

const CartContent = ({
  items,
  IncreaseQuantity,
  DecreaseQuantity,
  RemoveFromCart,
  GetTotal,
}) => {
  const dispatch = useDispatch();
  const isAuth = useSelector((state) => state.auth.isAuth);
  const token = useSelector((state) => state.auth.token && state.auth.token.value);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  console.log(user);

  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentError, setPaymentError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState(null);


  useEffect(() => {
    console.log("payment method", paymentMethod);
  }, [paymentMethod]);

  const triggerPaymentApi = async () => {

    if(!isAuth) {
      navigate("/login");
      return;
    }

    setIsLoading(true);
    const products = items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
    }));

    const body = {
      products: [...products],
      payment_method: paymentMethod,
    };

    console.log("body", body);

    try {
      const response = await axios.post(
        `${appConfig.apiUrl}/make/payment`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const { data } = response.data;
      setDatas(data);
      console.log("payment response", data);
      
    } catch (error) {
      console.log("error while making payment", error);
      setPaymentError(error.response.data.reason);
      setIsLoading(false)

    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (datas) {
      storePaymentInfos(datas);
    }
  }, [datas]) 

  const getTotalQuantity = (cart) => {
    let total = 0;
    cart.forEach((item) => {
      total += item.quantity;
    });

    return total;
  };

  const storePaymentInfos = (data$) => {
    console.log(data$);
    
// problème
    const orders = data$.orders;
    const ordersIds = orders.map(order => order.id )

    const paymentInfos = {
      identification: user.uuid,
      orderIds: ordersIds,
      paymentId: data$.payment_id,
      paymentMethod: paymentMethod,
    };
    // localStorage.setItem("paymentInfos", paymentInfos);

    if (paymentMethod === "paypal") {
      const paymentInfosString = JSON.stringify(paymentInfos);
      localStorage.setItem("paymentInfos", paymentInfosString);
      console.log("paypal", paymentInfos);

      window.location.href = data$.approval_url;
    } else if (paymentMethod === "stripe") {
      paymentInfos.secret_key = data$.client_secret;

      const paymentInfosString = JSON.stringify(paymentInfos);
      localStorage.setItem("paymentInfos", paymentInfosString);
      navigate("/stripe-payment");
      console.log("stripe", paymentInfos);
    }
  }

  return (
    <>
      {/* py-5 border */}
      {items.length > 0 ? (
        <div>
          <div className="row my-10 d-flex align-items-start rounded-2">
            <div className="col-md-7 ">
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <h3 className=" fw-normal">Shopping cart</h3>
                <p className="">
                  {" "}
                  {getTotalQuantity(items)}{" "}
                  {`item${getTotalQuantity(items) > 1 ? "s" : ""} in`}{" "}
                </p>
              </div>

              <hr />

              {items.length > 0 ? (
                items.map((item) => (
                  <div className="mb-2 rounded-2 border p-3" key={item.id}>
                    <div className="row align-items-center">
                      
                      <div className="col-auto border p-2 rounded-1">
                        <img
                          src={item.image[0].url}
                          alt={item.name.slice(0, 5)}
                          width="80"
                          height="60"
                        />
                      </div>
                      <div className="col">{item.name}</div>
                      <div className="col-auto">${item.price}</div>
                      <div className="col-auto">
                        <div className="d-flex align-items-center">
                          <span
                            className="btn btn-primary btn-xs me-1"
                            onClick={() => dispatch(DecreaseQuantity(item.id))}
                          >
                            -
                          </span>
                          <span className="btn btn-info btn-xs me-1">
                            {item.quantity}
                          </span>
                          <span
                            className="btn btn-primary btn-xs "
                            onClick={() => dispatch(IncreaseQuantity(item.id))}
                          >
                            +
                          </span>
                        </div>
                      </div>
                      <div className="col-auto">
                        <button
                          className="btn btn-danger btn-xs "
                          onClick={() => dispatch(RemoveFromCart(item.id))}
                        >
                          <BsTrash3Fill />
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center">Your cart is empty.</div>
              )}
            </div>

            <div className="col-md-5 ps-4"> 
            <div className="rounded-2 shadow-sm p-4">
              {paymentError && (
                <div className="alert alert-danger mt-2" role="alert">
                  {paymentError}
                </div>
              )}

              <h4 className="mb-3 fw-normal">Summary</h4>
              <hr className=" mb-4" />

              <MySelect
                label=" Payment mode"
                name="payment"
                handleChange={(e) => setPaymentMethod(e.target.value)}
                required={true}
                id={"payment"}
                values={[
                  { id: "paypal", name: "Paypal" },
                  { id: "stripe", name: "Credit card payment" },
                ]}
              />

              <hr className=" mt-6" />

              <div className="mt-3 mb-5 fw-bold form-label text-primary d-flex justify-content-between align-items-center">
                <span> Order total </span>
                <span className=" bg-soft-primary p-2 rounded-2 ">
                  ${GetTotal.totalPrice}
                </span>{" "}
              </div>

              <div className=" text-center">
                <button
                  className=" btn btn-sm  fs-5 btn-primary w-100 py-2"
                  onClick={triggerPaymentApi}
                  disabled={!paymentMethod || isLoading }
                >
                  {isLoading ? (
                    <div>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Processing...
                    </div>
                  ) :(
                    <span>
                      Checkout
                      {/* <i className="bi bi-arrow-right ms-2"></i> */}
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div> </div>
          <Link to={"/market-place"}>
            <button className="btn btn-link text-decoration-none fw-bold mb-5">
              <i className="bi bi-arrow-left me-2"></i> Back to Shop
            </button>
          </Link>
        </div>
      ) : (
        <div className="container content-space-2 content-space-lg-3">
      <div className="w-md-75 w-lg-50 text-center mx-md-auto">
        <div className="mb-5">
          <img alt="cartImg" className="img-fluid" src="../assets/img/svg/illustrations/oc-empty-cart.svg" style={{width: "15rem"}} />
        </div>

        <div className="mb-5">
          <h1 className="h2">Your cart is currently empty</h1>
          <p>Before proceed to checkout you must add some products to your shopping cart. You will find a lot of interesting products on our "Shop" page.</p>
        </div>
        
        {/* <a className="btn btn-primary btn-transition rounded-pill px-6" href="../demo-shop/index.html"></a> */}
        <Link to={"/market-place"}>
            <button className="btn btn-primary btn-transition rounded-pill px-6">
               Start shopping 
               {/* <ShoppingCart /> */}
            </button>
          </Link>
      </div>
    </div>
      )}
    </>
  );
};

export default CartContent;
